import { I18nApiService, setLangJSON } from '@zenlayer/zen-intl18';
import { useRequest } from 'ahooks';
import { useState } from 'react';

const setLangByEnv = async () => {
  try {
    const { getI18nStrings } = new I18nApiService({
      env: getRuntimeInfo().env,
      isProduction: __PRODUCTION__,
      projectId: __I18N_CONFIG__.id,
      gitBranch: __GIT_BRANCH__,
    });

    const i18nStrings = await getI18nStrings();
    setLangJSON({ text: i18nStrings });
  } catch (e) {
    setLangJSON({ text: {} });
    console.error(e);
  }
};

export function getPortalEnv() {
  return localStorage.getItem('PORTAL_ENV');
}

interface RuntimeInfo {
  env: 'dev' | 'ci' | 'auto' | 'pre' | 'prod';
  online: boolean;
  ga_code: string;
  location_host: string;
  has_mobile: boolean;
}
let runtimeInfo: RuntimeInfo;

export const getRuntimeInfo = () => {
  return runtimeInfo;
};
const setRuntimeInfo = (info: RuntimeInfo) => {
  runtimeInfo = info;
};

export default function useRuntimeInfo() {
  const [ready, setReady] = useState(false);

  useRequest(async () => {
    let success, data;
    if (!__PRODUCTION__) {
      window._zen_env_ = {
        env: 'ci',
        online: false,
        ga_code: 'GTM-PPCTK62',
        has_mobile: false,
        location_host: 'localhost',
        public_path: '/',
      };
    }

    success = true;
    const { _zen_env_ } = window;

    if (success) {
      let env = __PRODUCTION__
        ? _zen_env_.online
          ? 'ONLINE'
          : 'TEST'
        : 'DEVELOPMENT';

      localStorage.setItem('PORTAL_ENV', env);
      // loadGtmScript(data.ga_code));
      setRuntimeInfo(_zen_env_);
      await setLangByEnv();
      setReady(true);
    }
  });

  return {
    ready,
  };
}
